import { useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader, toast } from "@optymyse/suite-ui";
import { useCreateCompany } from "../lib/directory";
import { fill, strings } from "../lib/strings";
import { ApiError } from "../lib/api";
import { Page, Panel } from "../components/directory/Page";
import { bodyOf, CompanyForm, draftOf, type FormProblem } from "../components/directory/CompanyForm";

/** A new customer, made in the organisation's directory at Link, which every Optymyse app then reads. */
function NewCustomerPage() {
  const navigate = useNavigate();
  const create = useCreateCompany();
  const [problem, setProblem] = useState<FormProblem | null>(null);
  return (
    <Page>
      <PageHeader
        breadcrumb={[
          { label: strings.customers.title, href: "/admin/customers" },
          { label: strings.customers.form.newTitle },
        ]}
        title={strings.customers.form.newTitle}
      />
      <Panel>
        <CompanyForm
          initial={draftOf()}
          submitLabel={strings.customers.form.create}
          pending={create.isPending}
          problem={problem}
          onCancel={() => void navigate({ to: "/admin/customers" })}
          onSubmit={(draft) => {
            setProblem(null);
            create.mutate(bodyOf(draft), {
              onSuccess: (company) => {
                toast({ title: fill(strings.customers.form.created, { name: company.display_name }) });
                void navigate({ to: "/admin/customers/$companyId", params: { companyId: company.id } });
              },
              onError: (error) =>
                setProblem({
                  message: error.message,
                  field: error instanceof ApiError ? error.field : null,
                }),
            });
          }}
        />
      </Panel>
    </Page>
  );
}

export const Route = createFileRoute("/admin/customers/new")({ component: NewCustomerPage });
